<template>

  <div>

    <data-table
      table-ref="insurance-table"

      :title="title"
      icon="fa fa-shield-alt"

      :url="'/insurance' + (this.siteId ? '/site/' + Number(this.siteId) : '') + (this.telcoId ? '/org/' + Number(this.telcoId) : '')"

      :fields="insuranceFields"

      sort-field="policyType"
      :params="site"

      :add-action="isManager('finance|property|admin') ? addAction : null"
      :add-props="addProps"

      detail-component="insurance-detail-row" />

    </div>
</template>

<script>

/*
:add-action="addIns"
:add-props="addProps"
*/

import Vue from 'vue'
import VueEvents from 'vue-events'

import InsuranceAction from '@/components/actions/InsuranceAction'

import InsuranceDetails from '@/components/tables/details/InsuranceDetails'
import InsuranceControls from '@/components/tables/controls/InsuranceControls'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

Vue.component('insurance-detail-row', InsuranceDetails)
Vue.component('insurance-controls', InsuranceControls)

Vue.use(VueEvents)

export default {
  mixins: [DateMixins, NumberMixins],

  components: {
    InsuranceAction,
    InsuranceControls
  },

  props: {
    title: {
      type: String,
      default: 'Insurance Policies'
    },
    siteId: {
      type: Number,
      default: null
    },
    clientSiteId: {
      type: String,
      default: null
    },
    siteName: {
      type: String,
      default: null
    },

    sharerId: {
      type: Number,
      default: null
    },

    readOnly: {
      type: Boolean,
      default: false
    }

  },

  watch: {
    sharer: function (value) {
      this.telcoId = value
      this.$refs.insurancetable.refresh()
    }
  },

  methods: {
    formatStatus (value, inclText = false) {
      var icon = ''
      var color = 'darkgrey'

      if (value === 'Completed') {
        color = 'seagreen'
        icon = 'check-square'
      }

      if (value === 'KIV') {
        icon = 'clock'
      }

      if (value === 'Pending Payment') {
        color = 'goldenrod'
        icon = 'credit-card'
      }

      if (value === 'Approved') {
        color = 'seagreen'
        icon = 'thumbs-up'
      }

      if (value === 'Active') {
        color = 'slateblue'
        icon = 'check'
      }

      if (value === 'Terminated') {
        color = 'indianred'
        icon = 'bolt'
      }

      if (value === 'Pending') {
        color = 'goldenrod'
        icon = 'random'
      }

      return '<b><i class="fa fa-' + icon + '" style="color: ' + color + ';">' +
        '&nbsp;</i><span style="color: ' + color + ';">&nbsp;' +
        (this.isMobile ? '' : (inclText ? value : '')) +
        '</span></b>'
    }
  },

  data () {
    return {
      telcoId: this.sharer,
      addAction: InsuranceAction,

      addProps: {
        siteId: this.siteId,
        readOnly: this.readOnly
      },

      site: {
        siteId: this.siteId,
        clientSiteId: this.clientSiteId,
        siteName: this.siteName
      },

      insuranceFields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'policyType',
          title: 'Type',
          sortField: 'policyType'
        },
        {
          name: 'policyNo',
          title: 'Policy #',
          sortField: 'policyNo'
        },
        {
          name: 'provider.shortName',
          title: 'Provider',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'beneficary.shortName',
          title: 'Beneficiary',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'premium',
          title: 'Premium',
          sortField: 'premium',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatNumber
        },
        {
          name: 'frequency',
          title: 'Frequency',
          sortField: 'frequency',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'coverageStart',
          title: 'Started On',
          sortField: 'coverageStart',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          callback: this.formatDate
        },
        {
          name: 'coverageEnd',
          title: 'Expiry',
          sortField: 'coverageEnd',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          callback: this.formatDate
        },
        {
          name: '__component:insurance-controls',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          title: ''
        }
      ]
    }
  },

  mounted () {
    if (!this.telcoId && this.isTelco()) {
      this.telcoId = Number(this.org().id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// InsuranceTable.vue?59446482